module.exports = __webpack_public_path__ + "img/sucess.dfe41368.gif";